import { Component, OnInit,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { MyAccountService } from '../../../../services/myAccount.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../../services';
import { UserInfoViewModel, ActiveUserViewModel } from '../../../../models/account-ledger.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { DeleteConfirmComponent } from '../../../../popup-collection/delete-confirm/delete-confirm.component';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NgProgressService } from '../../../../services/ngProgress.service';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.css']
})
export class ManageUserComponent implements OnInit,OnDestroy {

  title = 'Edit User';
  setFullWindow = false;
  hide = true;
  isValidPassword = false;
  newPassword: string;
  adminChecked: boolean;
  purchaseChecked: boolean;
  userFormGroup: FormGroup;
  userInfo: UserInfoViewModel;
  checkedPromotions: boolean;
  checkedDatafeedsCsv: boolean;
  checkedDatafeedsXml: boolean;
  checkedOrderConfirmations: boolean;
  checkedInvoices: boolean;
  checkedOrderStatusUpdates: boolean;
  checkedBackorderETAUpdates: boolean;
  checkedAnnuityExpiryNotifications: boolean;
  checkedShippingReports: boolean;
  checkedStatements: boolean;
  activeUser: ActiveUserViewModel;
  currentUserInfo: UserInfoViewModel = <UserInfoViewModel>{};
  loadContent = false;

  currentUserSubscription:Subscription;

  user_validation_messages: any = {
    'loginName': [
      { class: 'loginNameValidate', message: 'Please enter login name' }
    ],
    'firstName': [
      { class: 'firstNameValidate', message: 'Please enter first name' }
    ],
    'lastName': [
      { class: 'lastNameValidate', message: 'Please enter last name' }
    ],
    'email': [
      { class: 'emailValidate', message: 'Please enter email' }
    ],
    // 'password': [
    //   { class: 'passwordValidate', message: 'Please enter password' }
    // ]
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngProgress: NgProgressService,
    private myAccountService: MyAccountService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private dialog: MatDialog
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });
  }

  ngOnInit() {
    $('#levelOne').animate({ scrollLeft: $('#manageUsers').width() + $('.child-sidebar').width() }, 400);

    this.userFormGroup.get('userGroup.email').valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      if (value.includes(' ')) {
        this.userFormGroup.get('userGroup.email').setValue(value.trim());
      }
    });

    this.currentUserSubscription = this.myAccountService.currentUserInfo.subscribe((res: ActiveUserViewModel) => {

      this.ngProgress.start();

      this.activeUser = res;
      if (!res || Object.keys(res).length == 0) {
        $('#levelOne').animate({ scrollLeft: 0 }, 400);
        this.router.navigate(['../users'], { relativeTo: this.activatedRoute.parent });
      } else {
        this.myAccountService.GetSalesDocuments(res.loginName).subscribe((model: UserInfoViewModel) => {
          this.currentUserInfo = model;
          this.userFormGroup.get('userGroup.loginName').setValue(this.currentUserInfo.loginName);
          this.userFormGroup.get('userGroup.firstName').setValue(this.currentUserInfo.firstName);
          this.userFormGroup.get('userGroup.lastName').setValue(this.currentUserInfo.lastName);
          this.userFormGroup.get('userGroup.email').setValue(this.currentUserInfo.email);
          // this.userFormGroup.get('userGroup.password').setValue(this.currentUserInfo.password);
          this.checkedPromotions = this.currentUserInfo.promotions;
          this.checkedDatafeedsCsv = this.currentUserInfo.dataFeed;
          this.checkedDatafeedsXml = this.currentUserInfo.stockCatalogue;
          this.checkedInvoices = this.currentUserInfo.invoices;
          this.checkedOrderConfirmations = this.currentUserInfo.orderConfs;
          this.checkedOrderStatusUpdates = this.currentUserInfo.orderStatusUpdates;
          this.checkedBackorderETAUpdates = this.currentUserInfo.etaUpdates;
          this.checkedAnnuityExpiryNotifications = this.currentUserInfo.annuityExpireUpdates;
          this.checkedShippingReports = this.currentUserInfo.shippingReports;
          this.checkedStatements = this.currentUserInfo.statements;
          this.adminChecked = this.currentUserInfo.isAdmin;
          this.purchaseChecked = this.currentUserInfo.isPurchaseOfficer;
          this.loadContent = true;
          this.ngProgress.done();


        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
      }
    },
      (error: any) => {
        console.error(error);
        this.ngProgress.done();
      });
    // $(".page-contents").animate({ scrollLeft: $("#levelOne").width() }, 400);

  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  saveUser(): void {
    this.ngProgress.start();
    if (this.userFormGroup.get('userGroup').valid) {
      if (this.newPassword && !this.isValidPassword) {
        this.commonService.showValidator('.passwordValidate', 'Password does not match the patterns', 'bottom', 'error');
        return;
      }
      this.userInfo = {
        loginName: this.userFormGroup.get('userGroup.loginName').value,
        accountId: '',
        firstName: this.userFormGroup.get('userGroup.firstName').value,
        lastName: this.userFormGroup.get('userGroup.lastName').value,
        email: this.userFormGroup.get('userGroup.email').value,
        password: this.newPassword,
        roles: '',
        mfaEnabled: '',
        isAdmin: this.adminChecked,
        isPurchaseOfficer: this.purchaseChecked,
        promotions: this.checkedPromotions,
        dataFeed: this.checkedDatafeedsCsv,
        stockCatalogue: this.checkedDatafeedsXml,
        invoices: this.checkedInvoices,
        orderConfs: this.checkedOrderConfirmations,
        orderStatusUpdates: this.checkedOrderStatusUpdates,
        etaUpdates: this.checkedBackorderETAUpdates,
        annuityExpireUpdates: this.checkedAnnuityExpiryNotifications,
        shippingReports: this.checkedShippingReports,
        statements: this.checkedStatements
      };
      this.myAccountService.UpdateUserProfile(this.userInfo).subscribe((res: ApiResponse) => {
        if (res.status) {
          this.commonService.showValidator('.saveuser', res.responseMessage, 'right', 'success');
          setTimeout(() => {
            $('#levelOne').animate({ scrollLeft: 0 }, 400);
            this.router.navigateByUrl('/myAccount/users?refresh=true');
          }, 2000);
        } else {
          this.commonService.showValidator('.saveuser', res.responseMessage, 'right', 'error');
        }
        this.ngProgress.done();
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
    } else {
      this.isNotValidField('userGroup.firstName', this.user_validation_messages.firstName);
      this.isNotValidField('userGroup.lastName', this.user_validation_messages.lastName);
      this.isNotValidField('userGroup.email', this.user_validation_messages.email);
      // this.isNotValidField('userGroup.password', this.user_validation_messages.password);
      this.ngProgress.done();
    }
  }

  deleteUser(): void {
    const dialogRef = this.dialog.open(DeleteConfirmComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.myAccountService.DeleteUser(this.activeUser.loginName).subscribe((res: ApiResponse) => {
          if (res.status) {
            this.commonService.showSuccess('.deleteuser', res.responseMessage, 'right');
            setTimeout(() => {
              this.router.navigateByUrl('/myAccount/users?refresh=true');
            }, 2000);
            this.ngProgress.done();
          } else {
            this.commonService.showError('.deleteuser', res.responseMessage, 'right');
            this.ngProgress.done();
          }
        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
      }
    });
  }

  getUserGroup(): FormGroup {
    return new FormGroup({
      loginName: new FormControl({value: '', disabled: true }, Validators.compose([Validators.required])),
      firstName: new FormControl('', Validators.compose([Validators.required])),
      lastName: new FormControl('', Validators.compose([Validators.required])),
      email: new FormControl('', this.commonService.emailValidatorRegex()),
      // password: new FormControl('')
    });
  }

  isNotValidField(path: string, validation: any): void {
    if (path === 'userGroup.email') {
      if (this.userFormGroup.get(path).hasError('required')) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
      } else if (this.userFormGroup.get(path).hasError('email')) {
        this.commonService.showValidator('.' + validation[0].class, 'Please enter a valid email address', 'right', 'error');
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
      }
    }


  }

checkIsValidPassoword(isValid: boolean) {
    this.isValidPassword = isValid;
}

getNewPassword(password: string) {
  this.newPassword = password;
}

close() {
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
    this.router.navigateByUrl('/myAccount/users');
  }

ngOnDestroy(){
  if(this.currentUserSubscription){
    this.currentUserSubscription.unsubscribe();
  }
}

}
